export default "__VITE_ASSET__DPQZJGz$__"